

































import { index, processed, rejectRow } from '@/api/withdrawals'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'thumbnail', label: 'T', slot: true, width: 60 },
      { prop: 'name', label: '门店名称', width: 150, slot: true },
      { prop: 'realname', label: '真实姓名', width: 120 },
      { prop: 'contact_mobile', label: '联系电话', width: 150, slot: true },
      { prop: 'bank_name', label: '银行', width: 80 },
      { prop: 'card_no', label: '卡号' },
      { prop: 'total', label: '金额', width: 80 },
      { prop: 'status', label: '状态', width: 100, slot: true },
      { prop: 'created_at', label: '提现时间', width: 150 }
    ]
  }

  async resolveRow (row: Record<string, any>) {
    this.$ask(async () => {
      await processed(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been processed')
    })
  }

  async rejectRow (row: Record<string, any>) {
    this.$ask(async () => {
      await rejectRow(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been processed')
    })
  }
}
